<div matDialogTitle>
  <span class="w-full">
    {{ 'Google Calendar' | siaTranslate }}
  </span>
  <mat-icon
    mat-button
    mat-dialog-close
    (click)="closeDialog()"
    class="sia-dialog-close-button flex"
  >
    Close
  </mat-icon>
</div>

<div
  mat-dialog-content
  class="flex w-full flex-col items-center justify-center"
  style="overflow: hidden"
>
  <div
    class="flex max-h-[300px] min-h-32 min-w-[400px] overflow-y-auto overflow-x-hidden"
  >
    @if (!logged) {
      <h3 class="w-full text-center font-semibold">
        {{ 'Nessun calendario sincronizzato' | siaTranslate }}
      </h3>
    }
    @if (calendars && calendars.length > 0) {
      <div class="list">
        <mat-selection-list [disabled]="spinner">
          @for (calendar of calendars; track $index) {
            <mat-list-option [(selected)]="calendar.sync" [value]="calendar.id">
              <mat-list-item>
                <span
                  [style]="'background: ' + calendar.backgroundColor"
                  class="sia-google-calendar-color"
                ></span>
                {{ calendar.summary }}
              </mat-list-item>
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }
  </div>

  @if (logged) {
    <button
      mat-flat-button
      (click)="syncGoogleCalendars()"
      [disabled]="spinner"
      class="w-full"
      [siaTooltip]="'Sincronizza calendari selezionati'"
    >
      <span>{{ 'Sincronizza' | siaTranslate }}</span>
      <mat-icon> sync </mat-icon>
    </button>
  }
</div>

<div mat-dialog-actions align="end">
  @if (logged) {
    <sia-google-logout-button
      [scope]="scopeType"
      [buttonText]="'Disconnetti' | siaTranslate"
      [isLogged]="logged"
      [disabled]="spinner"
      (loginChanged)="logout()"
    >
    </sia-google-logout-button>
  } @else if (!logged) {
    <sia-google-auth-button
      [scope]="scope"
      [scopeType]="scopeType"
      [scopeName]="scopeName"
      [buttonText]="'Sincronizza' | siaTranslate"
      [isLogged]="logged"
      (tokenChanged)="login($event)"
      [client_id]="client_id"
    ></sia-google-auth-button>
  }
</div>
@if (spinner) {
  <div
    class="spinner items-center justify-center"
    style="position: absolute; top: 50%; left: calc(50% - 40px)"
  >
    <mat-spinner style="z-index: 110" [diameter]="80"></mat-spinner>
  </div>
}
